import { zeroPrice } from "@@/shared/prices/price";
import { z } from "zod";
import type {
    FeeSourceOrdersFilterDeliveryType} from "./fee-source-orders-filters-delivery-type";
import {
    feeSourceOrdersFilterDeliveryTypeFactory,
    feeSourceOrdersFilterDeliveryTypeZodSchema,
} from "./fee-source-orders-filters-delivery-type";
import type {
    FeeSourceOrdersFilterDestination} from "./fee-source-orders-filters-destination";
import {
    feeSourceOrdersFilterDestinationFactory,
    feeSourceOrdersFilterDestinationZodSchema,
} from "./fee-source-orders-filters-destination";
import type {
    FeeSourceOrdersFilterPaymentProvider} from "./fee-source-orders-filters-payment-provider";
import {
    feeSourceOrdersFilterPaymentProviderFactory,
    feeSourceOrdersFilterPaymentProviderZodSchema,
} from "./fee-source-orders-filters-payment-provider";
import type {
    FeeSourceOrdersFilterPrice} from "./fee-source-orders-filters-price";
import {
    feeSourceOrdersFilterPriceFactory,
    feeSourceOrdersFilterPriceZodSchema,
} from "./fee-source-orders-filters-price";

type FeeSourceOrdersFilter =
    | FeeSourceOrdersFilterDeliveryType
    | FeeSourceOrdersFilterDestination
    | FeeSourceOrdersFilterPaymentProvider
    | FeeSourceOrdersFilterPrice;

const feeSourceOrdersFilterZodSchema = z.union([
    feeSourceOrdersFilterDeliveryTypeZodSchema,
    feeSourceOrdersFilterDestinationZodSchema,
    feeSourceOrdersFilterPaymentProviderZodSchema,
    feeSourceOrdersFilterPriceZodSchema,
]);

type FeeSourceOrdersFilterType = FeeSourceOrdersFilter["type"];

const feeSourceFactory = (type: FeeSourceOrdersFilterType) => {
    switch (type) {
        case "DELIVERY_TYPE":
            return feeSourceOrdersFilterDeliveryTypeFactory({
                deliveryType: "HOME_DELIVERY",
            });
        case "PAYMENT_PROVIDER":
            return feeSourceOrdersFilterPaymentProviderFactory({
                paymentProvider: "STRIPE",
            });
        case "PRICE":
            return feeSourceOrdersFilterPriceFactory({
                orderPrice: zeroPrice,
                comparison: "equal",
            });
        case "DESTINATION":
            return feeSourceOrdersFilterDestinationFactory({
                destination: "?destio?",
            });
    }
};

export { feeSourceFactory, feeSourceOrdersFilterZodSchema };
export type { FeeSourceOrdersFilter };
